import { html, LitElement } from "lit";
import { customElement, property, query } from "lit/decorators.js";

@customElement('text-input')
export class TextInput extends LitElement {

    // Props

    @property({ type: Boolean, reflect: true })
    disabled: boolean = false; 
    
    @property({ type: Boolean, reflect: true })
    required: boolean = false; 

    @property({ type: String, reflect: true  })
    name: string = '';

    @property({ type: String })
    autocomplete: string = '';

    @property({ type: String })
    placeholder: string = '';

    @property({ type: String, reflect: true  })
    value: string = '';

    @query('input')
    _input!: HTMLInputElement;

    // Lifecycle Hooks

    firstUpdated() {

        // class list
        this.classList.add('TextInput');

    }

    // Render

    render() {
        return html`
            <input 
                type="text" 
                name="${ this.name }" 
                .autocomplete="${ this.autocomplete }" 
                placeholder="${ this.placeholder }"
                ?required="${ this.required }" 
                .value="${ this.value }"
                @input="${ this._handleInput }"
            />
        `;
    }

    createRenderRoot() { 
        return this;
    }

    // Methods

    private _handleInput() {
        this.value = this._input.value;
        const event = new Event('input');
        this.dispatchEvent(event);
    }


}